import Button, {
  ButtonStyling,
} from '../../../../../components/form/elements/button';
import { useState } from 'react';
import Link from '../../../../../components/form/elements/link';
import { route } from '../../../../../services/utils';
import { WAREHOUSE_WAREHOUSES_INDEX } from '../../../../../router/routes';
import { useParams } from 'react-router-dom';

export function useCreateFooter(
  isModal: boolean = false,
  setModalVisible: (state: boolean) => void = undefined
) {
  const { farmId } = useParams<{
    farmId: string;
  }>();

  const [footer] = useState(() => [
    Button('create'),
    isModal
      ? Button(
          'cancel',
          () => setModalVisible(false),
          undefined,
          undefined,
          undefined,
          true,
          ButtonStyling.cancel
        )
      : Link(route(WAREHOUSE_WAREHOUSES_INDEX, { farmId }), 'cancel'),
  ]);

  return footer;
}
